import type { TenantModuleKey } from "@loot-os/api-contract";
import {
  BarChart3,
  Bell,
  Hammer,
  Headset,
  type LucideIcon,
  MessagesSquare,
  Radio,
  Store,
  Swords,
  Truck,
} from "lucide-react";

import { ShopifyIcon } from "./shopifyIcon";

/**
 * One icon per tenant module, for the Tenants list's at-a-glance column. The pages that have a
 * sidebar icon (Analytics, Storefront, Shipping, Shopify) use that same one.
 */
export const TENANT_MODULE_ICONS: Record<TenantModuleKey, LucideIcon> = {
  analytics: BarChart3,
  storefront: Store,
  battles: Swords,
  chat: MessagesSquare,
  forge: Hammer,
  liveBreaks: Radio,
  supportChat: Headset,
  notifications: Bell,
  shipping: Truck,
  shopify: ShopifyIcon,
};
